export default class LoginModel {
    public type = LoginModel

    public email = ''
    public password = ''

    constructor(options?: Partial<LoginModel>) {
        Object.assign(this, options)
    }
}
